import Vue from 'vue';
import VueRouter from 'vue-router';
import {default as routes, getRouteMeta} from './routes.js';
import store from '../store/index.js';
import {ls} from "../store/local-store";
import {USER__SET_USER} from "../views/user/action-types";
import {MAP__SET_STATE_MAP_VISIBLE} from '../components/main-map/type-actions'
import { shareMgr } from '../utils/share/index.js';

Vue.use(VueRouter);

Vue.prototype.$getRouteMeta = getRouteMeta;

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch(err => err)
};

const router = new VueRouter({
  routes,
	scrollBehavior() {
  	return {x: 0, y: 0};
	}
});

// 防止刷新丢失用户信息
const user = ls.getItem('user');
if (user) {
	store.dispatch(`user/${USER__SET_USER}`, user);
}

router.beforeEach((to, from, next) => {
  const cityId = store.state.app.cityId || ls.getItem('cityId') || to.query.cityId
	// let {id: userId} = store.state.user.user || ls.getItem('user') || {}
  // const sessionId = store.state.user.sessionId || ls.getItem('sessionId')
  // const link = getShareLink({
  //   cityId,
  //   redirectUrl: window.location.href,
  //   inviterUserId: userId,
  //   inviterSessionId: sessionId
  // })
  // console.log('router share link:', link)
  // 微信分享初始化
		shareMgr.init({
			url: window.location.href,
			cityId
		})

  if (to.name !== 'Login') {
    // 隐藏分享按钮
    shareMgr.installReady(() => {
      shareMgr.hideWxMenus()
      // shareMgr.showWxMenus('menuItem:share:appMessage')
      // wx.updateAppMessageShareData({
      //   title: document.title,
      //   desc: '',
      //   link,
      //   imgUrl: ''
      // })
    })
  } else {
    shareMgr.installReady(() => {
      shareMgr.hideWxMenus()
    })
  }

  // 设置地图显示/隐藏
  store.dispatch(MAP__SET_STATE_MAP_VISIBLE, to.meta.mapVisible)

	if (to.name === 'Login' && store.state.user.user) { // 如果已登录，禁止进入登录页面
		next(false);
	} else { // 默认进入
		next();
	}
});

router.afterEach((to) => {
	function onBridgeReady() {
		WeixinJSBridge.call('hideOptionMenu');
		// 通过下面这个API隐藏底部导航栏
		WeixinJSBridge.call('hideToolbar');
	}

	if (typeof WeixinJSBridge == "undefined") {
		if (document.addEventListener) {
			document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
		} else if (document.attachEvent) {
			document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
			document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
		}
	} else {
		onBridgeReady();
	}
	if (getRouteMeta(to, 'needAuth') && !store.state.user.user) { // 需要登录的页面自动跳转登录页
		router.push({
			name: 'Login',
			params: {
				from: to, // 将目标路由传给登录页，用于登录后返回
			}
		});
		return;
	}
});

export default router;
